import Form from "../components/Form";
import Navbar from "../components/Navbar";

const ContactPage = () => {
  return (
    <div >
      <Navbar />
      <div className="about pt-[5rem]">
        <Form/>
      </div>
    </div>
  )
};

export default ContactPage;
